import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Integration.UsBank.Update.IRequest;
type Params = Api.Core.Integration.UsBank.Update.IParams;
type Response = Api.Core.Integration.UsBank.Update.IResponse;
type Headers = Api.Core.Integration.UsBank.Update.IHeaders;
const url = '/api/UsBank/Payment/:usBankCardId';
export default async function usBankUpdateApi(params: Params, body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, params),
    body: body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
